﻿export interface SharedStringTable { readonly strings: string[]; readonly index: Map<string, number>; }
export function createSharedStringTable(): SharedStringTable { return { strings: [""], index: new Map([["", 0]]) }; }
export function internString(table: SharedStringTable, value: string): number {
  const e = table.index.get(value); if (e !== undefined) return e;
  const id = table.strings.length;
  if (id > 0xffff) throw new Error("sharedStringTable capacity exceeded");
  table.strings.push(value); table.index.set(value, id); return id;
}
export function lookupString(table: SharedStringTable, id: number): string { return table.strings[id] ?? ""; }
export function totalCharCount(table: SharedStringTable): number { let n = 0; for (const s of table.strings) n += s.length; return n; }
export function size(table: SharedStringTable): number { return table.strings.length; }
